import React from "react";
import { Link } from "react-router-dom";

const ContactInformation = ({ email, link }) => {
	return (
		<>
			<p className="pt-5 text-base font-thin ">
				<strong>Contact Information</strong>
				<br />
				For questions regarding these Client Services Agreement, please contact:
				<br />
				<span>
					📧{" "}
					<Link
						to={`mailto:${email}`}
						className="duration-300 ease-in hover:underline hover:text-blue-600">
						{email}
					</Link>
				</span>
				<br />
				<span>
					📍{" "}
					<Link
						to={link}
						className="duration-300 ease-in hover:underline hover:text-blue-600">
						Toronto, ON. Canada
					</Link>
				</span>
			</p>
		</>
	);
};

export { ContactInformation };
export default ContactInformation;
